import { styled } from 'next-yak';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  SkeletonCard,
  SkeletonHeadline as DefaultSkeletonHeadline,
} from '@xing-com/skeleton';
import {
  scale280,
  scale390,
  scale440,
  spaceM,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';

import { PRODUCT_CARD_HEIGHT } from '../product-cards.styled';

export const LoadingCardContainer = styled(SkeletonCard)`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: ${spaceXL};
  height: ${PRODUCT_CARD_HEIGHT};
  max-width: ${scale440};
  padding: ${spaceXXL} !important;
  border-radius: ${spaceXXL} !important;

  @media ${mediaSmallOrTiny} {
    flex: 0 0 ${PRODUCT_CARD_HEIGHT};
    min-width: ${scale390};
    width: 100%;
  }
`;

export const LoadingCardBenefits = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXL};

  & > div:last-child {
    display: flex;
    flex-direction: column;
    gap: ${spaceM};
  }
`;

export const SkeletonHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXL};
`;

export const SkeletonHeadline = styled(DefaultSkeletonHeadline)`
  width: ${scale280};
`;
